import { apiClient } from "helpers/api_helper";

export const getInterStoreInventoryProduct = async (style: any ,kt: any) => {
    try {
        const response = await apiClient.get(`/api/v1/InterStoreTransfer/SearchInterStoreProduct?styleNo=${style}&ktId=${kt}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GetStylesSelectList = async () => {
    try {
        const response = await apiClient.get('/api/v1/StylesMaster/GetStylesSelectList')
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const GetAllKaratList = async () => {
    try {
        const response = await apiClient.get('/api/v1/Karat/GetKaratSelectList')
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const InsertInterStoreTransfer = async (payload: any) => {
    try {
        const response = await apiClient.post('/api/v1/InterStoreTransfer/InsertInterStoreTransfer', payload);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GetInterStoreOderList = async (data:object) => {
    try {
        const response = await apiClient.get('/api/v1/InterStoreTransfer/GetInterStoreOderList',data)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const ReassignProductToOrder = async (id : any) => {
    try {
        const response = await apiClient.get(`api/v1/InterStoreTransfer/ReassignProductToOrder?id=${id}`)
        return response;
    } catch (error : any) {
        throw new Error(error.message);
    }
}

export const GenerateInterStoreInvoice = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/v1/InterStoreTransfer/GenerateInterStoreInvoice?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const UpdateInterStoreOrderStatus = async (data: { id: number; status: string }) => {
    try {
        const response = await apiClient.get(`/api/v1/InterStoreTransfer/UpdateInterStoreOrderStatus?id=${data.id}&status=${data.status}`)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}